import { call, put } from 'redux-saga/effects';
import { Saga } from 'custom-types/saga';

import { addNegativeToast, errorIdentifier } from 'modules/toastContainer';
import { analyticsMetricsList } from 'modules/experiments/ducks/actions';
import { ExperimentsAction, PerformanceTabQuery } from 'modules/experiments/types';
import { AnalyticsMetric } from 'modules/graphql';
import { getExperimentsTranslations } from 'modules/experiments/utils';
import { fetchExperimentAnalyticsMetrics } from 'api/ExperimentsAPI';

type ExperimentAnalyticsSaga = Saga<ExperimentsAction<Record<string, unknown>, AnalyticsMetric[]>>;

type FetchExperimentAnalyticsMetricsData = {
  data: {
    analyticsMetrics: AnalyticsMetric[];
  };
};

// To prevent querying for analytics metrics multiple time for the same experiment
// We cache the first experiment id that was fetched
let fetchedExperimentId: number;

export function* setAnalyticsMetricsDataSaga({
  queryData,
}: ExperimentsAction<{ queryData: PerformanceTabQuery }>): ExperimentAnalyticsSaga {
  try {
    // If analytics metrics has already been pulled for the expID do nothing
    if (fetchedExperimentId === queryData.id) return;
    fetchedExperimentId = queryData.id;

    const {
      data: { analyticsMetrics },
    }: FetchExperimentAnalyticsMetricsData = yield call(
      fetchExperimentAnalyticsMetrics,
      queryData.messageMedium,
    );

    yield put(analyticsMetricsList(analyticsMetrics));
  } catch (error) {
    const errorMessage = yield call(
      getExperimentsTranslations,
      'errorMessage.analyticsMetricsList',
    );

    yield put(
      addNegativeToast(
        errorMessage,
        errorIdentifier({
          errorMessage,
          source: 'setPerformanceTabDataSaga',
          error,
          additional: queryData,
        }),
      ) as any,
    );
  }
}
